import { RootState } from "../reducers";

export const getAllDestinationsForLocationSelection = (state: RootState) => state.dropoffLocationSelection.destinations;
export const getCurrentGeoCoordinates = (state: RootState) => state.currentLocation?.geometry?.location;
export const getDestination = (state: RootState) => state.destination;
export const getNearbyDestinations = (state: RootState) => state?.nearByDestinations;
export const getNearbyDestinationError = (state: RootState) => state?.nearByDestinations.error;
export const getNearbyPlaces = (state: RootState) => state.nearByDestinations.places;
export const getTowInfo = (state: RootState) => state.destination.towInfo;